import { Menu } from 'react-pro-sidebar';
import { Icon, styled, IconButton } from '../../../base';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    margin: theme.spacing(1.375, 0),
    padding: 0,
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'background-color 0.1s',
    '&:hover': {
        backgroundColor: theme.palette.common.white,
    },
    '&:hover .side-menu-icon': {
        color: theme.palette.primary.main,
    },
}));

export const StyledIcon = styled(Icon)(({ theme }) => ({
    color: theme.palette.common.white,
    transition: 'color 0.1s',
    display: 'flex',
}));

export const LogoContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '106px',
    width: '100%',
    marginBottom: '26px',
}));

export const StyledLogo = styled('img')(() => ({
    height: '44px',
}));

export const StyledMenu = styled(Menu)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: 0,
}));
